import Vue from "vue";
import store from "../vuex/store";
import R from "ramda";

Vue.directive("applyRules", {
  bind(el, binding, vNode, oldNode) {
    // let niveis = {
    //   0: 'USUÁRIO',
    //   1: 'ADMINISTRADOR',
    //   2: 'CONTABILISTA',
    //   3: 'CLIENTE',
    //   4: 'MODERADOR'
    // }
    let user = store.getters.getUser;
    let canBeDisabled = R.is(Boolean, el.disabled);
    let isGranted = binding.value
      ? binding.value.some((x) => x === user.level.idNivel)
      : false;
    canBeDisabled
      ? (el.disabled = !isGranted)
      : (vNode.elm.hidden = !isGranted);
  },
  update(el) {},
  unbind(el) {},
});
